import { useMemo } from 'react';

// Import the game images
import huntingImage from '@/images/hunting.avif';
import motorsportImage from '@/images/motorsport_series.jpg';
import defaultImage from '@/images/NACON.png';
import sessionImage from '@/images/session.jpg';
import tduImage from '@/images/TDUSC.png';

// Standalone exports for use in non-component contexts (e.g., route handles)
export const gameImageMap: Record<string, string> = {
  hs3: huntingImage,
  ems: motorsportImage,
  session: sessionImage,
  tdusc: tduImage,
};

export const getGameImage = (gameCode: string): string => {
  return gameImageMap[gameCode.toLowerCase()] ?? defaultImage;
};

export const useGameImage = () => {
  const memoizedGameImageMap = useMemo(() => gameImageMap, []);

  return { getGameImage, gameImageMap: memoizedGameImageMap };
};
